import type { GlobalID } from './global-id';

import { decode as base64_decode, encode as base64_encode } from 'base-64';

export function fromGlobalID(rawID: string): GlobalID {
  const fromB64 = base64_decode(rawID);

  const [type, id] = fromB64.split(':');

  return {
    id,
    type,
  };
}
